import React from 'react'
import Logo from '../../Assests/mainLogo.png'
import FbIcon from '../../Assests/Facebook Icon.svg'
import InstaIcon from '../../Assests/Instagram Icon.svg'

function Footer() {
  return (
    <div style={{ backgroundColor: '#1A0010', color: '#fff' }}>

      {/* Main footer content */}
      <div className='sm:grid sm:grid-cols-3 gap-12 sm:mx-[192px] mx-6 pt-16 pb-12' style={{ borderBottom: '1px solid rgba(228,15,148,0.25)' }}>

        {/* Brand column */}
        <div>
          <img src={Logo} className='w-[80px] h-[76px] mb-4' alt="Chilanka Logo" />
          <div className='text-[20px] font-bold mb-3' style={{ fontFamily: 'Playfair Display, serif', color: '#fff' }}>
            Chilanka Dance School
          </div>
          <p className='text-[13px] leading-relaxed max-w-[260px]' style={{ color: '#C48AAA' }}>
            Celebrating the living tradition of Indian classical and folk dance. Nurturing artists, building community, honoring heritage.
          </p>
          <div className='flex gap-3 mt-6'>
            <a href='https://www.facebook.com/share/1Q9Hu18jMV/?mibextid=wwXIfr'>
              <img src={FbIcon} className='h-8 w-8' style={{ opacity: 0.85 }} alt="Facebook" />
            </a>
            <a href='https://www.instagram.com/chilankadanceschool?igsh=d2pvbm9uODE1NjR2&utm_source=qr'>
              <img src={InstaIcon} className='h-8 w-8' style={{ opacity: 0.85 }} alt="Instagram" />
            </a>
          </div>
        </div>

        {/* Quick links */}
        <div className='sm:mt-0 mt-10'>
          <div className='text-[10px] uppercase font-bold mb-5' style={{ letterSpacing: '3px', color: '#E40F94' }}>
            Quick Links
          </div>
          <ul className='space-y-3 text-[14px]'>
            {[
              { label: 'Home', path: '/' },
              { label: 'About Us', path: '/aboutPage' },
              { label: 'Classes', path: '/classes' },
              { label: 'Summer Camp', path: '/summerCampPage' },
              { label: 'Gallery', path: '/galleryPage' },
            ].map((link, i) => (
              <li key={i}>
                <a href={link.path} style={{ color: '#D4A0BC' }}>{link.label}</a>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div className='sm:mt-0 mt-10'>
          <div className='text-[10px] uppercase font-bold mb-5' style={{ letterSpacing: '3px', color: '#E40F94' }}>
            Contact
          </div>
          <ul className='space-y-4 text-[14px]' style={{ color: '#D4A0BC' }}>
            <li className='flex gap-2 items-start'>
              <span>📍</span>
              <span>2880 Broadway Bend Drive, Building 2<br />Pearland, TX 77584</span>
            </li>
            <li className='flex gap-2 items-center'>
              <span>📞</span>
              <span>(469) 556-3040</span>
            </li>
            <li className='flex gap-2 items-center'>
              <span>✉️</span>
              <span>chilankahouston@gmail.com</span>
            </li>
          </ul>
        </div>

      </div>

      {/* Bottom bar */}
      <div className='text-center py-6 text-[12px]' style={{ letterSpacing: '1px', color: '#C48AAA' }}>
        <strong style={{ color: '#E40F94' }}>✦ CHILANKA DANCE SCHOOL ✦</strong>
        <span className='mx-3'>·</span>
        Move. Inspire. Shine.
        <span className='mx-3'>·</span>
        © 2025 All Rights Reserved.
      </div>

    </div>
  )
}

export default Footer
